<template>
    <div> 
        <Breadcrumbs main="Admin" submain="" title="Change Password" />
        <!-- Container-fluid starts-->
        <div class="container-fluid">
            <div class="row">
                <div class="col-sm-12">
                    <px-card>
                        <div slot="with-padding">
                            <div class="form theme-form">
                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Old Password</label>
                                            <input class="form-control" type="text" placeholder="Enter your first name" v-model="password.old_password" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>New Password</label>
                                            <input class="form-control" type="text" placeholder="Enter your email address" v-model="password.new_password" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>

                                <div class="row">
                                    <div class="col-sm-6">
                                        <div class="form-group">
                                            <label>Confirm New Password</label>
                                            <input class="form-control" type="text" placeholder="Enter your nid no." v-model="password.confirm_password" style="height: 44px;">
                                        </div>
                                    </div>
                                </div>
    
                                <div class="row mt-4">
                                    <div class="col">
                                        <div class="form-group mb-0">
                                            <button @click="onSubmit" class="btn btn-success mr-3" :disabled="isDisabled">Update</button>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </px-card>
                </div>
            </div>
        </div>
        <!-- Container-fluid Ends-->
    </div>
</template>
    
<script>
    import { mapState } from 'vuex';
    import Datepicker from 'vuejs-datepicker';
    import vue2Dropzone from 'vue2-dropzone';
    import 'vue2-dropzone/dist/vue2Dropzone.min.css';
    import Multiselect from 'vue-multiselect';
    import Swal from 'sweetalert2/dist/sweetalert2.js'
    import 'sweetalert2/src/sweetalert2.scss'
    
    export default {
        components: {
            vueDropzone: vue2Dropzone,
            Datepicker,
            Multiselect
        },
    
        data() {
            return {
                isDisabled: false,
                password: {
                    old_password: '',
                    new_password: '',
                    confirm_password: ''
                },
            }
        },
    
        methods: {
            onSubmit() {
                if (!this.password.old_password || this.password.old_password.trim() === '') {
                    Swal.fire({
                        title: "Error!",
                        text: "Old password is required.",
                        icon: "error"
                    });
                    return;
                }
                if (!this.password.new_password || this.password.new_password.length < 8 || !/[!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]/.test(this.password.new_password)) {
                    Swal.fire({
                        title: "Error!",
                        text: "New password must be at least 8 characters and contain a special character.",
                        icon: "error"
                    });
                    return;
                }
                if (this.password.new_password !== this.password.confirm_password) {
                    Swal.fire({
                        title: "Error!",
                        text: "Confirm password does not match.",
                        icon: "error"
                    });
                    return;
                }
                this.isDisabled = true;

                this.$store.dispatch("admin/updatePassword", this.password).then(response => {
                    if (response.code == 200) {
                        this.isDisabled = false,
                        this.password.old_password = ''
                        this.password.new_password = ''
                        this.password.confirm_password = ''
                        Swal.fire({
                            title: "Success!",
                            text: response.response,
                            icon: "success"
                        });
                    } else {
                        Swal.fire({
                            title: "Error!",
                            text: response.response,
                            icon: "error"
                        });
                    }
                })
            }
        }
    };
</script>
    